import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import { LogService } from "../../../services/LogService";

export default {
    name: "IndexConfiguracao",
    components: {
        Breadcrumb
    },
    data: () => ({
        logs: [],
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Configuração de Log',
                disabled: true
            }
        ],
    }),
    created() {
        this.buscaLogsIniciais();
    },
    methods: {
        async save() {
            try {
                const formData = new FormData();

                this.logs.forEach(log => {
                    formData.append('logs[]', JSON.stringify(log));
                });

                await LogService.store(formData);

            } catch (error) {
                console.error("Erro ao salvar os logs:", error);
            }
        },
        async buscaLogsIniciais() {
            try {
                const response = await LogService.entidades();
                if (response) {
                    this.logs = response.data;
                } else {
                    console.error('Não foi possível obter as logs.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao obter as logs:', error);
            }
        }
    }
};